import { PointOfSale } from 'shared';

import { isLocalhost } from './routes';

const countryCodePointOfSaleMap: Record<string, PointOfSale> = {
  au: PointOfSale.AU,
  at: PointOfSale.AT,
  be: PointOfSale.BE,
  cn: PointOfSale.CN,
  dk: PointOfSale.DK,
  fi: PointOfSale.FI,
  fr: PointOfSale.FR,
  de: PointOfSale.DE,
  hk: PointOfSale.HK,
  is: PointOfSale.IS,
  ie: PointOfSale.IE,
  it: PointOfSale.IT,
  jp: PointOfSale.JP,
  lt: PointOfSale.LT,
  nl: PointOfSale.NL,
  no: PointOfSale.NO,
  pl: PointOfSale.PL,
  ru: PointOfSale.RU,
  sg: PointOfSale.SG,
  es: PointOfSale.ES,
  se: PointOfSale.SE,
  ch: PointOfSale.CH,
  th: PointOfSale.TH,
  gb: PointOfSale.GB,
  us: PointOfSale.US,
  lu: PointOfSale.LU,
  ca: PointOfSale.CA,
  kr: PointOfSale.KR,
};

const localePattern = /^\/([a-z]{2})-[a-z]{2}\//;

export const getPointOfSaleFromLocation = ({
  hostname,
  pathname,
}: {
  hostname: string;
  pathname: string;
}): PointOfSale => {
  const topLevelDomain = hostname.split('.').pop();

  const topLevelDomainPos = topLevelDomain ? countryCodePointOfSaleMap[topLevelDomain] : undefined;

  if (topLevelDomainPos) {
    return topLevelDomainPos;
  }

  const match = pathname.match(localePattern);

  const countryCode = match?.[1] ?? '';
  const pos = countryCodePointOfSaleMap[countryCode];
  if (pos) {
    return pos;
  }

  return isLocalhost() ? countryCodePointOfSaleMap.se : countryCodePointOfSaleMap.lu;
};
